import { styled } from "@mui/material";

const StyledAsterisk = styled("span")`
  color: ${(props) => props.theme.palette.error.main};
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
`;

export const RequiredAdornment = (): React.ReactNode => {
  return <StyledAsterisk>*</StyledAsterisk>;
};
